import { Component } from "react";
import Header from "../common/Header";
import Footer from "../common/Footer";
import { LinkDetail } from './PublicFunctions';
import { TutorialDetail } from './PublicFunctions';
import phplogo from "../../assets/images/phptutorial.png";
import javascriptlogo from "../../assets/images/javascripttutorial.png";
import jquerylogo from "../../assets/images/jquerytutorial.png";
import ajaxlogo from "../../assets/images/ajaxtutorial.png";
import codeigniterlogo from "../../assets/images/codeignitertutorial.png";
import laravellogo from "../../assets/images/laraveltutorial.png";
import apilogo from "../../assets/images/apitutorial.png";
import loadingImage from "../../assets/img/loading.gif";
import reactjslogo from "../../assets/images/reactjs.png";
import nodejslogo from "../../assets/images/node.png";
import Meta from "./Meta";
import AdSenseAd160x600 from "./AdSenseAd160x600";


class Tutorial extends Component {
  constructor() {
    super()
    this.state = {
      postlink: [],
      posts: [],
      submitted: false,
      isLoading: true
    }
  }

  componentDidMount() {
    const tutorialId = this.props.match.params.tutId;
    const Id = this.props.match.params.Id;
    LinkDetail(tutorialId).then(res => {
      this.setState({
        postlink: res.data

      })
    })
    TutorialDetail(tutorialId, Id).then(res => {
      this.setState({
        posts: res.data,
        isLoading: false

      })
    })
  }
  render() {
    const tutId = this.props.match.params.tutId;
    let tutlogo, tutname, title, keywords, description;
    const { isLoading, posts, postlink } = this.state;
    if (tutId === 'php') {
      tutlogo = phplogo;
      tutname = "PHP Tutorial";
      title = "PHP Tutorial for Beginners, Learn PHP Step-by-Step, PHP Crash Course";
      keywords = "PHP Tutorial, PHP Step-by-Step, PHP Crash Course";
      description = "This PHP Tutorial is for Beginners, if anyone want paid training whatsapp me 9911097721 or call";
    }
    else if (tutId === 'javascript') {
      tutlogo = javascriptlogo;
      tutname = "Javascript Tutorial";
      title = "Javascript Tutorial for Beginners, Learn Javascript Step-by-Step, Javascript Crash Course";
      keywords = "Javascript Tutorial, Javascript Step-by-Step, Javascript Crash Course";
      description = "This Javascript Tutorial is for Beginners, if anyone want paid training whatsapp me 9911097721 or call";
    }
    else if (tutId === 'jquery') {
      tutlogo = jquerylogo;
      tutname = "jQuery Tutorial";
      title = "jQuery Tutorial for Beginners, Learn jQuery Step-by-Step, jQuery Crash Course";
      keywords = "jQuery Tutorial, jQuery Step-by-Step, jQuery Crash Course";
      description = "This jQuery Tutorial is for Beginners, if anyone want paid training whatsapp me 9911097721 or call";
    }
    else if (tutId === 'ajax') {
      tutlogo = ajaxlogo;
      tutname = "Ajax Tutorial";
      title = "Ajax Tutorial for Beginners, Learn Ajax Step-by-Step, Ajax Crash Course";
      keywords = "Ajax Tutorial, jQuery Step-by-Step, Ajax Crash Course";
      description = "This Ajax Tutorial is for Beginners, if anyone want paid training whatsapp me 9911097721 or call";
    }
    else if (tutId === 'codeigniter') {
      tutlogo = codeigniterlogo;
      tutname = "Codeigniter Tutorial";
      title = "Codeigniter Tutorial for Beginners, Learn Codeigniter Step-by-Step, Codeigniter Crash Course";
      keywords = "Codeigniter Tutorial, Codeigniter Step-by-Step, Codeigniter Crash Course";
      description = "This Codeigniter Tutorial is for Beginners, if anyone want paid training whatsapp me 9911097721 or call";
    }
    else if (tutId === 'laravel') {
      tutlogo = laravellogo;
      tutname = "Laravel Tutorial";
      title = "Laravel Tutorial for Beginners, Learn Laravel Step-by-Step, Laravel Crash Course";
      keywords = "Laravel Tutorial, Laravel Step-by-Step, Laravel Crash Course";
      description = "This Laravel Tutorial is for Beginners, if anyone want paid training whatsapp me 9911097721 or call";
    }
    else if (tutId === 'api') {
      tutlogo = apilogo;
      tutname = "API Tutorial";
      title = "API Tutorial for Beginners, API Step-by-Step, API Crash Course";
      keywords = "API Tutorial, API Step-by-Step, API Crash Course";
      description = "This API Tutorial is for Beginners, if anyone want paid training whatsapp me 9911097721 or call";
    }
    else if (tutId === 'react') {
      tutlogo = reactjslogo;
      tutname = "ReactJS Tutorial";
      title = "ReactJS Tutorial for Beginners, Learn ReactJS Step-by-Step, ReactJS Crash Course";
      keywords = "ReactJS Tutorial, ReactJS Step-by-Step, ReactJS Crash Course";
      description = "This ReactJS Tutorial is for Beginners, if anyone want paid training whatsapp me 9911097721 or call";
    }
    else if (tutId === 'node') {
      tutlogo = nodejslogo;
      tutname = "Node Tutorial";
      title = "Node.js Tutorial for Beginners, Learn Node Step-by-Step, Node.js Crash Course";
      keywords = "Node.js Tutorial, Node Step-by-Step, Node.js Crash Course";
      description = "This Node.js Tutorial is for Beginners, if anyone want paid training whatsapp me 9911097721 or call";
    }
    return (
      <div>
        {isLoading && (
          <div className="loading">
            <img src={loadingImage} alt={loadingImage} className="mx-auto d-block loading-image" ></img>
          </div>
        )}
        <Meta
          title={title}
          keywords={keywords}
          description={description}
        />
        <Header />
        <main role="main">
          <div className="background">
            <div className="container">
              <div className="row">
                <div className="col-sm-3">
                  <div className="leftblue">
                    <div align="center" className="paddingleft">
                      <img src={tutlogo} width="240" height="180" alt="{tutname}" />
                      <div className="head4">{tutname}</div>
                      {postlink.map((post, i) => {
                        return (
                          <div key={i}>
                            <div class="typetext"><a href={post.id} class="tcolor">{post.subcategory_name}</a>
                            </div>
                          </div>
                        )
                      })}
                    </div>
                  </div>
                </div>
                <div class="col-sm-7">
                  {posts.map((post, i) => {
                    return (
                      <div className="container" key={i}>
                        <div class="heading2">{post.topic_heading}</div>
                        <div class="content">
                          <div dangerouslySetInnerHTML={{ __html: post.topic_desc }}></div>
                        </div>
                      </div>

                    )
                  })}

                </div>
                <div className="col-sm-2">
                  <div className="col-sm-2">
                  </div>
                  <div class="thumbnail">
                    <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#c32324' }}>Tutorial</div>
                    <div>
                      <a href="/tutorial/php/1" class="rightdiv1">PHP Tutorial</a>
                    </div>
                    <div>
                      <a href="/tutorial/javascript/3" class="rightdiv1">Javascript Tutorial</a>
                    </div>
                    <div>
                      <a href="/tutorial/jquery/64" class="rightdiv1">Jquery Tutorial</a>
                    </div>
                    <div>
                      <a href="/tutorial/ajax/4" class="rightdiv1">Ajax Tutorial</a>
                    </div>
                    <div>
                      <a href="/tutorial/codeigniter/68" class="rightdiv1">Codeigniter Tutorial</a>
                    </div>
                    <div>
                      <a href="/tutorial/laravel/101" class="rightdiv1">Laravel Tutorial</a>
                    </div>
                    <div>
                      <a href="/tutorial/api/127" class="rightdiv1">API Tutorial</a>
                    </div>
                    <div>
                      <a href="/tutorial/react/137" class="rightdiv1">React Tutorial</a>
                    </div>
                    <div>
                      <a href="/tutorial/node/151" class="rightdiv1">Node Tutorial</a>
                    </div>
                    <br />
                    <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#c32324' }}>Example</div>
                    <div>
                      <a href="/example/php/1" class="rightdiv1">PHP Example</a>
                    </div>
                    <div>
                      <a href="/example/javascript/23" class="rightdiv1">Javascript Example</a>
                    </div>
                    <div>
                      <a href="/example/jquery/63" class="rightdiv1">Jquery Example</a>
                    </div>
                    <div>
                      <a href="/example/ajax/33" class="rightdiv1">Ajax Example</a>
                    </div>
                    <div>
                      <a href="/example/codeigniter/66" class="rightdiv1">Codeigniter Example</a>
                    </div>
                    <div>
                      <a href="/example/laravel/68" class="rightdiv1">Laravel Example</a>
                    </div>
                    <div>
                      <a href="/example/api/66" class="rightdiv1">API Example</a>
                    </div>
                    <div>
                      <a href="/example/react/83" class="rightdiv1">React Example</a>
                    </div>
                    <div>
                      <a href="/example/node/84" class="rightdiv1">Node Example</a>
                    </div>
                     <br />
                    <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#c32324' }}>Interview(Q/A)</div>
                    <div>
                      <a href="/interview/php" class="rightdiv1">PHP (Q/A)</a>
                    </div>
                    <div>
                      <a href="/interview/javascript" class="rightdiv1">Javascript (Q/A)</a>
                    </div>
                     <div>
                      <a href="/interview/ajax" class="rightdiv1">Ajax (Q/A)</a>
                    </div>
                     <div>
                      <a href="/interview/codeigniter" class="rightdiv1">Codeigniter (Q/A)</a>
                    </div>
                     <div>
                      <a href="/interview/laravel" class="rightdiv1">Laravel (Q/A)</a>
                    </div>
                     <div>
                      <a href="/interview/api" class="rightdiv1">API (Q/A)</a>
                    </div>
                     <div>
                      <a href="/interview/react" class="rightdiv1">React (Q/A)</a>
                    </div>
                     <div>
                      <a href="/interview/node" class="rightdiv1">Node (Q/A)</a>
                    </div>
                     <div>
                      <a href="/interview/javascriptchallenges" class="rightdiv1">JS challenges (Q/A)</a>
                    </div>
                     <div>
                      <a href="/interview/mongodb" class="rightdiv1">Mongo DB (Q/A)</a>
                    </div>
                     <div>
                      <a href="/interview/database" class="rightdiv1">Database (Q/A)</a>
                    </div>
                     <div>
                      <a href="/interview/techlead" class="rightdiv1">Tech Lead (Q/A)</a>
                    </div>
                    <div>
                      <a href="/interview/aws" class="rightdiv1">AWS (Q/A)</a>
                    </div>
                    <div>
                    {AdSenseAd160x600}
                    </div>

                  </div>

                </div>

              </div>
            </div>

          </div>
        </main>
        <Footer />
      </div>
    );
  }
}
export default Tutorial;
